import { render, staticRenderFns } from "./lotes.vue?vue&type=template&id=870a232c&scoped=true&"
import script from "./lotes.vue?vue&type=script&lang=js&"
export * from "./lotes.vue?vue&type=script&lang=js&"
import style0 from "./lotes.vue?vue&type=style&index=0&id=870a232c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870a232c",
  null
  
)

export default component.exports